import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  buttonCancel: {
    '&.MuiButton-root': {
      padding: '8px 16px',
    },
  },
}));

export default useStyles;
